import { useQueryClient } from '@tanstack/react-query';
import {
  getApiV1PersonIdPhotoQueryOptions,
  usePostApiV1PersonIdPhoto,
} from '@/shared/api/generated';

/**
 * Hook para fazer upload da foto de perfil de uma pessoa.
 * Invalida o cache da foto após upload bem-sucedido.
 *
 * @param personId - ID da pessoa
 * @returns Mutation de upload com `mutate({ id, data: { file } })`
 *
 * @example
 * ```tsx
 * const upload = useUploadPhoto(personId);
 * upload.mutate({ id: personId, data: { file: blob } });
 * ```
 */
export function useUploadPhoto(personId: number) {
  const queryClient = useQueryClient();

  return usePostApiV1PersonIdPhoto({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(getApiV1PersonIdPhotoQueryOptions(personId));
      },
    },
  });
}
